import { createSVGWrapper } from "./SVGWrapper";

/**
 * @deprecated This icon is deprecated. Please use Lucide React icons instead.
 * @see https://lucide.dev/ for available icons
 * @example
 * import { Trash2 } from "lucide-react";
 * // Use <Trash2 /> instead
 */
export const TrashBinIcon = createSVGWrapper(
  <>
    <path
      d="M9 3C9 2.44772 9.44772 2 10 2H14C14.5523 2 15 2.44772 15 3V4H18C18.5523 4 19 4.44772 19 5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5C5 4.44772 5.44772 4 6 4H9V3Z"
      fill="currentColor"
    />
    <path
      fill="currentColor"
      d="M18.5 8H5.5L6.84356 19.5399C6.93665 20.4088 7.59175 21.1183 8.44863 21.2897C10.7789 21.7558 13.2211 21.7558 15.5514 21.2897C16.4083 21.1183 17.0633 20.4088 17.1564 19.5399L18.5 8ZM11 11C11 10.4477 10.5523 10 10 10C9.44771 10 9 10.4477 9 11V18C9 18.5523 9.44771 19 10 19C10.5523 19 11 18.5523 11 18V11ZM14 10C14.5523 10 15 10.4477 15 11V18C15 18.5523 14.5523 19 14 19C13.4477 19 13 18.5523 13 18V11C13 10.4477 13.4477 10 14 10Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </>
);
